import { useTranslation } from 'react-i18next';
import { CustomTextOptions } from 'interfaces/WidgetConfigs.interface';
import { JSX, createElement, ComponentType } from 'preact';
import { getCustomTextFactory, CustomTextDefault } from './CustomText.util';

type ElementType = keyof JSX.IntrinsicElements | ComponentType<any>;

type PropsOf<T extends ElementType> = T extends keyof JSX.IntrinsicElements
  ? JSX.IntrinsicElements[T]
  : T extends ComponentType<infer P>
  ? P
  : never;

interface CustomTextOwnProps<T extends ElementType = 'div'> {
  as?: T;
  text: string | CustomTextOptions;
  defaultText?: CustomTextDefault;
  options?: Record<string, string>;
}

type CustomTextProps<T extends ElementType = 'div'> = CustomTextOwnProps<T> &
  Omit<PropsOf<T>, keyof CustomTextOwnProps<T>>;

export const CustomText = <T extends ElementType = 'div'>({
  as,
  text,
  defaultText,
  options = {},
  ...restProps
}: CustomTextProps<T>): JSX.Element => {
  const { t } = useTranslation();
  const Component = (as || 'div') as any;

  const getCustomText = getCustomTextFactory(t);
  const customText = getCustomText(text, defaultText, options);

  return createElement(Component, {
    ...restProps,
    dangerouslySetInnerHTML: { __html: customText },
  });
};
